var DeviceCategory;
(function (DeviceCategory) {
    DeviceCategory["Tag"] = "TAG";
    DeviceCategory["Anchor"] = "ANCHOR";
})(DeviceCategory || (DeviceCategory = {}));
export function mapDeviceCategory(category) {
    switch (category) {
        case DeviceCategory.Tag:
            return "Tag";
        case DeviceCategory.Anchor:
            return "Anchor";
        default:
            return category ?? "Unknown";
    }
}
export default DeviceCategory;
//# sourceMappingURL=device-category.js.map